import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';
import CommonBreadCurmb from '../components/common/CommonBreadCrumb';
import catAdminUtils from '../util/catAdminUtils';
import consts from '../consts';
import Connection from '../services/Connection';
import { usePrerequisites } from '../contexts/Prerequisites';
import { itemSyncConfig } from "../AppGrid/ItemSyncTable";
import Model from '../models/model';
import { itemLogColumns } from '../AppGrid/EndoSetupSopes';
import HookupDetailTable from '../AppGrid/HookupDetailTable';
import ScopeModelDetail from '../AppGrid/ScopeModelDetailTable';

const hookupSyncColumns = itemSyncConfig.columns.map(column => {
	const updatedColumn = { ...column };

	switch (updatedColumn.field) {
		case 'SerialNumber':
			updatedColumn.required = true;
			break;
		case 'ItemName':
			updatedColumn.excludeOnGrid = true;
			updatedColumn.required = false;
			break;
		default:
			// No changes for other fields
			break;
	}

	return updatedColumn;
});

const HookupSyncTable = new Model({
	...itemSyncConfig,
	name: 'HookupSync',
	api: 'ItemSync',
	gridTitle: 'HookupInventory',
	formGroups: [{
		fields: ["SerialNumber", "Manufacturer", "ItemType", "Model", "IsActive", "ReSync",
			"LastResyncOn", "InterFacedYN", "DataSource", "EquipmentName", "DeviceTypes", "ItemCodes", "EquipmentModel", "Department"
		]
	}],
	importProps: {
		importUrl: Connection.EndoSetupHookupRapidAER, message: "ScopesCountWarning", maxCount: consts.maxScopesCount, logColumns: itemLogColumns,
		fileType: consts.endoImportSpec.Hookups.fileType, type: consts.endoImportSpec.Hookups.type
	},
	columns: hookupSyncColumns
}).createFormBase();

const HookupSync = () => {
	const [{ strings }] = usePrerequisites();
	const [searchParams]= useSearchParams();
    const hookupValue = searchParams.get('value') || '';
	const id = searchParams.get('id') || '';

	// Memoize parentFilters to avoid unnecessary re-renders
    const parentFilters = useMemo(() => {
            return {
                filter: [{ "operator": "$eq", "value": hookupValue, "property": "HookupValue" }]
        }}, [hookupValue]);
	return <>
		{/* Hiding the grids for HookupSync form */}
		{ !id && <HookupDetailTable disablePreferences={true} parentFilters={parentFilters} /> }
		{ !id && <ScopeModelDetail disablePreferences={true} parentFilters={parentFilters} /> }
		<CommonBreadCurmb
			docTitle={strings.HookupSync}
			breadcrumbs={[{ text: strings.HookupSync }]}
			Component={HookupSyncTable}
			handleSubmit={catAdminUtils.handleOnSubmit}
			maxCount={consts.maxScopesCount}
			message={strings.ScopesCountWarning}
			apiUrl={Connection.ItemSync}
			navigateUrl={-1} // Navigate back to the previous page
		/>
	</>
};

export default HookupSync;